import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../../redux/deviations/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        isOwner: getIsCurrentUserAuthorOf(state, deviation),
    });
};
export default connect(mapStateToProps);
//# sourceMappingURL=Comments.container.js.map